import { render, staticRenderFns } from "./WalletAdminSummaryCard.vue?vue&type=template&id=33875c98&scoped=true&"
import script from "./WalletAdminSummaryCard.vue?vue&type=script&lang=js&"
export * from "./WalletAdminSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./WalletAdminSummaryCard.vue?vue&type=style&index=0&id=33875c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33875c98",
  null
  
)

export default component.exports